#import "../../../graphql/fragments/meeting-fragment.graphql"

mutation CreateManagedMeetingTemplate($input: ManagedMeetingTemplateCreateInput!) {
    managedMeetingTemplateCreate(input: $input) {
        meeting {
            ...MeetingFragment
        }
    }
}
